<template>
  <div class="pt-2">
    <v-row v-if="filtersReady">
      <component
        v-for="(item, index) in selectedAdminFilters"
        :key="index"
        :is="item"
        :items="parsingGroups"
        :statuses="parsingStatus"
        :label="availableAdminFilters[item]"
        v-model="filters[item]"
        @remove="removeFilter(item)"
      ></component>
      <v-col
        :sm="isEmpty(availableFilters) ? 6 : 12"
        :md="isEmpty(availableFilters) ? 4 : 8"
        :lg="isEmpty(availableFilters) ? 2 : 4"
        class="align-self-center"
      >
        <v-menu
          v-if="!isEmpty(availableFilters)"
          top
          :close-on-content-click="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              outlined
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              class="mr-2"
            >
              <v-icon x-small>mdi-plus</v-icon>
              Add filter
            </v-btn>
          </template>

          <v-list width="250px">
            <v-list-item-group>
              <v-virtual-scroll
                :height="availableFilters.length * 40"
                :itemHeight="40"
                :items="availableFilters"
              >
                <template v-slot:default="{ item }">
                  <v-list-item>
                    <v-list-item-title @click="addFilter(item.key)">{{
                      item.label
                    }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-btn
          x-small
          outlined
          color="grey darken-1"
          dark
          @click="resetFilters"
        >
          reset Filters
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import TextFilter from "@/views/components/searchParts/TextFilter";
import BooleanFilter from "@/views/components/searchParts/BooleanFilter";
import AllowedResourceSearch from "@/views/components/searchParts/AllowedResourceSearch";

import { mapGetters, mapState } from "vuex";
import { SET_EMPTY_FILTERS } from "@/store/modules/admin/actions";
import { emptyFilters } from "@/store/modules/admin/state";
import {
  REMOVE_ADMIN_FILTER,
  ADD_ADMIN_FILTER,
  SET_DEFAULT_ADMIN_FILTERS,
  SET_ADMIN_FILTERS,
} from "@/store/modules/persistentStorage/actions";

export default {
  name: "AdminSearch",
  components: {
    allowedResources: AllowedResourceSearch,
    name: TextFilter,
    email: TextFilter,
    isActive: BooleanFilter,
  },
  data: function () {
    return {
      filtersReady: false,
      parsingGroups: [
        {
          key: "0",
          item: 0,
        },
        {
          key: "1",
          item: 1,
        },
        {
          key: "2",
          item: 2,
        },
        {
          key: "3",
          item: 3,
        },
        {
          key: "4",
          item: 4,
        },
      ],
      parsingStatus: [
        {
          key: "Error",
          item: -1,
        },
        {
          key: "Warning",
          item: 0,
        },
        {
          key: "Success",
          item: 1,
        },
      ],
    };
  },
  computed: {
    ...mapState("admin", ["filters"]),
    ...mapGetters("persistentStorage", [
      "selectedAdminFilters",
      "availableAdminFilters",
    ]),
    availableFilters: function () {
      let vm = this;
      let result = [];

      const filtersToSelect = _.difference(
        _.keys(emptyFilters),
        this.selectedAdminFilters
      );

      filtersToSelect.forEach(function (filter) {
        result.push({
          key: filter,
          label: _.get(vm.availableAdminFilters, filter),
        });
      });
      return result;
    },
  },
  watch: {
    selectedAdminFilters: {
      handler: function () {
        let query = _.merge({}, this.$route.query);
        query["selectedFilters"] = _.merge([], this.selectedAdminFilters);
        query["page"] = this.$route.query.page;
        this.$router.push({ name: this.$route.name, query: {} }).catch((e) => {
          console.log(e);
        });
        this.$router
          .push({ name: this.$route.name, query: query })
          .catch(() => {});
      },
      deep: true,
    },
  },
  methods: {
    addFilter: function (filter) {
      this.$store.dispatch(`persistentStorage/${ADD_ADMIN_FILTER}`, filter);
    },
    removeFilter: function (filter) {
      this.$store.dispatch(`persistentStorage/${REMOVE_ADMIN_FILTER}`, filter);
      this.filters[filter] = null;
    },
    resetFilters: function () {
      this.$store.dispatch(`admin/${SET_EMPTY_FILTERS}`);
      this.$store.dispatch(`persistentStorage/${SET_DEFAULT_ADMIN_FILTERS}`);
    },
    isEmpty: function (value) {
      return _.isEmpty(value);
    },
  },
  mounted: function () {
    const vm = this;

    let query = Object.assign({}, this.$route.query);
    if (!_.isEmpty(query) && query["selectedFilters"]) {
      let selectedFilters = query["selectedFilters"];
      if (!(selectedFilters instanceof Array)) {
        selectedFilters = [selectedFilters];
      }
      this.$store.dispatch(
        `persistentStorage/${SET_ADMIN_FILTERS}`,
        selectedFilters
      );
    }
    if (!_.isEmpty(query)) {
      _.forIn(query, function (value, filter) {
        if (_.find(vm.availableFilters, ["key", filter])) {
          vm.addFilter(filter);
        }
      });
    }
    vm.filtersReady = true;
  },
};
</script>
